export default __webpack_public_path__ + "static/media/monisha.6583a1af.jpg";